import { theme } from '../../styles/theme';
const basePracticeStatusBadge = {
    padding: '8px',
    fontSize: '12px',
    fontWeight: 600,
    borderRadius: '32px',
    width: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    '> img': {
        marginRight: '5px',
        width: '20px',
        height: '20px'
    }
};
export const practiceStatusBadgeCompleted = {
    ...basePracticeStatusBadge,
    border: `1px solid ${theme.palette.common.feedbackInfo50}`,
    background: theme.palette.common.feedbackInfo10,
    color: theme.palette.common.darkGrey2
};
export const practiceStatusBadgeIncomplete = {
    ...basePracticeStatusBadge,
    background: theme.palette.common.feedbackWarning10,
    border: `1px solid ${theme.palette.common.feedbackWarning50}`,
    color: theme.palette.common.primaryDark
};
//# sourceMappingURL=PracticeStatusBadge.styles.js.map